// The pages of their own (no map): one table for web/main.ts's startup and for its hash handler, which reloads into a
// page when a link or Back lands on one. Everything else is the map app (web/hash.ts).

export type Page = "report" | "listing" | "about" | "help" | "terms" | "privacy" | "account" | "panel";

const PAGES: Array<{ page: Page | "doc"; re: RegExp }> = [
  { page: "report", re: /^#\/report\/(.+)$/ }, // printable report: #/report/<geo id>
  { page: "listing", re: /^#\/listing(?:\?(.*))?$/ }, // listing analyzer: its inputs in the query
  { page: "doc", re: /^#\/(about|help|terms|privacy|account)$/ },
  { page: "panel", re: /^#\/panel\/([^?]+)(?:\?(.*))?$/ }, // the area panel alone, for the iOS app: #/panel/<geo id>?…
];

/** The page a hash opens, with its area id and query; null = the map app. */
export function pageOf(hash: string): { page: Page; geo: string | null; query: URLSearchParams } | null {
  for (const p of PAGES) {
    const m = p.re.exec(hash);
    if (!m) continue;
    if (p.page === "doc") return { page: m[1] as Page, geo: null, query: new URLSearchParams() };
    if (p.page === "listing") return { page: "listing", geo: null, query: new URLSearchParams(m[1] ?? "") };
    return { page: p.page, geo: decodeURIComponent(m[1]!), query: new URLSearchParams(m[2] ?? "") };
  }
  return null;
}
